import { Component, ViewChild, inject } from '@angular/core';
import { MotionService } from '../../../../../motion/motion.service';
import { NightDriveComponent } from '../../../../../motion/night-drive/night-drive.component';

/** Band 3 "Night Drive": the WebGL highway above #contact, with the tagline and the contact CTA. */
@Component({
  selector: 'app-home-band-night',
  templateUrl: './home-band-night.component.html',
  styleUrl: './home-band-night.component.css',
})
export class HomeBandNightComponent {
  readonly motion = inject(MotionService);
  @ViewChild('nd') private nd?: NightDriveComponent;

  /** Throttle, then arrive: the boost holds for the whole scroll down to #contact. */
  go(event: Event): void {
    // Modified or non-primary clicks open the href in a new tab/window as usual.
    if (event instanceof MouseEvent && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
      return;
    }
    const nd = this.nd;
    nd?.holdBoost(true);
    this.motion.scrollToSection('contact', event).finally(() => nd?.holdBoost(false));
  }
}
